import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Streax = () => {

return (

<div>

<Navbar />
<Flexproducts type="streax" />
<Header></Header>

</div>

);
};

export default Streax;